import { Navigate, useLocation } from 'react-router-dom'
import { LoadingScreen } from '@/components/ui/LoadingScreen'
import { useAuth } from '@/contexts/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRole?: string
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!isAuthenticated) {
    // Redirect to login, but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Check for required role if specified
  if (requiredRole && user) {
    if (user.role !== requiredRole && user.role !== 'admin') {
      // User doesn't have the required role - redirect to dashboard
      return <Navigate to="/dashboard" replace />
    }
  }

  return <>{children}</>
}
